module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-597.8e1f8ef.woff2";